import { ChainID, SUI_ARCHIVE_GRPC_PATH } from '@ankr.com/chains-list';

import alloraIcon from './icons/allora.svg';
import alloraIconDark from './darkModeIcons/allora.svg';
import abchainIcon from './icons/ab.svg';
import aptosIcon from './icons/aptos.svg';
import arbitrumIcon from './icons/arbitrum.svg';
import arbitrumNovaIcon from './icons/arbitrum-nova.svg';
import avaxIcon from './icons/avax.svg';
import bscIcon from './icons/bsc.svg';
import botanixIcon from './icons/botanix.svg';
import bttcIcon from './icons/bttc.svg';
import btcIcon from './icons/btc.svg';
import celoIcon from './icons/celo.svg';
import chilizIcon from './icons/chiliz.svg';
import coreIcon from './icons/core.svg';
import defaultIcon from './icons/default-icon.svg';
import ethIcon from './icons/eth.svg';
import etherlinkIcon from './icons/etherlink.svg';
import filecoinIcon from './icons/filecoin.svg';
import flareIcon from './icons/flare.svg';
import ftmIcon from './icons/ftm.svg';
import gnosisIcon from './icons/gnosis.svg';
import harmonyIcon from './icons/harmony.svg';
import horizenIcon from './icons/horizen.svg';
import hecoIcon from './icons/heco.svg';
import iotexIcon from './icons/iotex.svg';
import iotaIcon from './icons/iota.svg';
import kiteIcon from './icons/kite.svg';
import kintoIcon from './icons/kinto.svg';
import kaiaIcon from './icons/kaia.svg';
import kusamaIcon from './icons/kusama.svg';
import metisIcon from './icons/metis.svg';
import blastIcon from './icons/blast.svg';
import bitlayerIcon from './icons/bitlayer.svg';
import moonbeamIcon from './icons/moonbeam.svg';
import multichainIcon from './icons/multichain.svg';
import nearIcon from './icons/near.svg';
import neuraIcon from './icons/neura.svg';
import whitechainIcon from './icons/whitechain.svg';
import worldchainIcon from './icons/worldchain.svg';
import nervosIcon from './icons/nervos.svg';
import optimisimIcon from './icons/optimism.svg';
import polkadotIcon from './icons/polkadot.svg';
import plasmaIcon from './icons/plasma.svg';
import polygonIcon from './icons/polygon.svg';
import polygonZkevmIcon from './icons/polygon-zkevm.svg';
import secretIcon from './icons/secret.svg';
import solIcon from './icons/sol.svg';
import stakeIcon from './icons/stake.svg';
import suiIcon from './icons/sui.svg';
import syscoinIcon from './icons/syscoin.svg';
import taikoIcon from './icons/taiko.svg';
import tronIcon from './icons/tron.svg';
import redbellyIcon from './icons/redbelly.svg';
import robinhoodIcon from './icons/robinhood.svg';
import rolluxIcon from './icons/rollux.svg';
import mantleIcon from './icons/mantle.svg';
import zetachainIcon from './icons/zetachain.svg';
import baseIcon from './icons/base.webp';
import scrollIcon from './icons/scroll.svg';
import okxX1Icon from './icons/okx.svg';
import okxX1IconDark from './darkModeIcons/okx.svg';
import tenetIcon from './icons/tenet.svg';
import zksyncEraIcon from './icons/zksync_era.svg';
import availIcon from './icons/avail.svg';
import telosIcon from './icons/telos.svg';
import tonIcon from './icons/ton.svg';
import fuelIcon from './icons/fuel.svg';
import atletaIcon from './icons/atleta.svg';
import swellIcon from './icons/swell.svg';
import cornIcon from './icons/corn.svg';
import goatIcon from './icons/goat.svg';
import sonicIcon from './icons/sonic.svg';
import monadIcon from './icons/monad.svg';
import dogeosIcon from './icons/dogeos.svg';
import somniaIcon from './icons/somnia.svg';
import somniaIconDark from './darkModeIcons/somnia.svg';
import zkverifyIcon from './icons/zkverify.svg';
import zkverifyIconDark from './darkModeIcons/zkverify.svg';
import xphereIcon from './icons/xphere.svg';
import xphereIconDark from './darkModeIcons/xphere.svg';
import xrpIcon from './icons/xrp.svg';
import xrpIconDark from './darkModeIcons/xrp.svg';
import midnightIcon from './icons/midnight.svg';
import midnightIconDark from './darkModeIcons/midnight.svg';
import iotaIconDark from './darkModeIcons/iota.svg';
import sonicIconDark from './darkModeIcons/sonic.svg';
import matchainIcon from './icons/matchain.svg';
import matchainIconDark from './darkModeIcons/matchain.svg';
import atletaIconDark from './darkModeIcons/atleta.svg';
import arbitrumNovaIconDark from './darkModeIcons/arbitrum-nova.svg';
import bttcIconDark from './darkModeIcons/bttc.svg';
import ethIconDark from './darkModeIcons/eth.svg';
import kavaIcon from './icons/kava.svg';
import zeroGIcon from './icons/zero-g.svg';
import kusamaIconDark from './darkModeIcons/kusama.svg';
import moonbeamIconDark from './darkModeIcons/moonbeam.svg';
import nearIconDark from './darkModeIcons/near.svg';
import nervosIconDark from './darkModeIcons/nervos.svg';
import solIconDark from './darkModeIcons/sol.svg';
import kintoIconDark from './darkModeIcons/kinto.svg';
import suiIconDark from './darkModeIcons/sui.svg';
import mantleIconDark from './darkModeIcons/mantle.svg';
import tenetIconDark from './darkModeIcons/tenet.svg';
import zksyncEraIconDark from './darkModeIcons/zksync_era.svg';
import berachainIconDark from './darkModeIcons/berachain.svg';
import blastIconDark from './darkModeIcons/blast.svg';
import berachainIcon from './icons/berachain.svg';
import seiIcon from './icons/sei.svg';
import xdcIcon from './icons/xdc.svg';
import b2Icon from './icons/b2.svg';
import xaiIcon from './icons/xai.svg';
import bahamutIcon from './icons/bahamut.svg';
import movementIcon from './icons/movement.svg';
import storyIcon from './icons/story.svg';
import xdcIconDark from './darkModeIcons/xdc.svg';
import lineaIcon from './icons/linea.svg';
import electroneumIcon from './icons/electroneum.svg';
import lineaIconDark from './darkModeIcons/linea.svg';
import stellarIcon from './icons/stellar.svg';
import gravityIcon from './icons/gravity.svg';
import stellarIconDark from './darkModeIcons/stellar.svg';
import bitlayerIconDark from './darkModeIcons/bitlayer.svg';
import syscoinIconDark from './darkModeIcons/syscoin.svg';
import taikoIconDark from './darkModeIcons/taiko.svg';
import scrollIconDark from './darkModeIcons/scroll.svg';
import coreIconDark from './darkModeIcons/core.svg';
import seiIconDark from './darkModeIcons/sei.svg';
import kaiaIconDark from './darkModeIcons/kaia.svg';
import availIconDark from './darkModeIcons/avail.svg';
import telosIconDark from './darkModeIcons/telos.svg';
import electroneumIconDark from './darkModeIcons/electroneum.svg';
import zeroGIconDark from './darkModeIcons/zero-g.svg';
import tacIcon from './icons/tac.svg';
import tacIconDark from './icons/tac-dark.svg';
import unichainIcon from './icons/unichain.svg';
import hyperevmIcon from './icons/hyperevm.svg';
import hyperevmIconDark from './icons/hyperevm-dark.svg';
import statusIcon from './icons/status.svg';
import statusIconDark from './icons/statusDark.svg';

const chainIcons: Partial<Record<ChainID, string>> = {
  [ChainID.ALLORA]: alloraIcon,
  [ChainID.ALLORA_MAINNET_REST]: alloraIcon,
  [ChainID.ALLORA_MAINNET_RPC]: alloraIcon,
  [ChainID.ALLORA_MAINNET_COSMOS_REST]: alloraIcon,
  [ChainID.ALLORA_MAINNET_GRPC]: alloraIcon,
  [ChainID.ALLORA_TESTNET]: alloraIcon,
  [ChainID.ALLORA_TESTNET_REST]: alloraIcon,
  [ChainID.ALLORA_TESTNET_RPC]: alloraIcon,
  [ChainID.ALLORA_TESTNET_COSMOS_REST]: alloraIcon,
  [ChainID.ALLORA_TESTNET_GRPC]: alloraIcon,
  [ChainID.ABCHAIN]: abchainIcon,
  [ChainID.ABCHAIN_TESTNET]: abchainIcon,
  [ChainID.APTOS]: aptosIcon,
  [ChainID.ARBITRUM]: arbitrumIcon,
  [ChainID.ARBITRUM_TESTNET]: arbitrumIcon,
  [ChainID.ARBITRUM_SEPOLIA]: arbitrumIcon,
  [ChainID.ARBITRUM_NOVA]: arbitrumNovaIcon,
  [ChainID.AVALANCHE]: avaxIcon,
  [ChainID.AVALANCHE_C]: avaxIcon,
  [ChainID.AVALANCHE_EVM]: avaxIcon,
  [ChainID.AVALANCHE_FUJI]: avaxIcon,
  [ChainID.AVALANCHE_FUJI_C]: avaxIcon,
  [ChainID.AVALANCHE_FUJI_EVM]: avaxIcon,
  [ChainID.AVALANCHE_FUJI_P]: avaxIcon,
  [ChainID.AVALANCHE_FUJI_X]: avaxIcon,
  [ChainID.AVALANCHE_P]: avaxIcon,
  [ChainID.AVALANCHE_X]: avaxIcon,
  [ChainID.ATLETA]: atletaIcon,
  [ChainID.ATLETA_OLYMPIA]: atletaIcon,

  [ChainID.AVAIL]: availIcon,
  [ChainID.AVAIL_GOLDBERG_TESTNET]: availIcon,
  [ChainID.AVAIL_TURING_TESTNET]: availIcon,

  [ChainID.GOAT]: goatIcon,
  [ChainID.GOAT_TESTNET]: goatIcon,

  [ChainID.BSC]: bscIcon,
  [ChainID.BSC_TESTNET_CHAPEL]: bscIcon,

  [ChainID.BAHAMUT]: bahamutIcon,
  [ChainID.BAHAMUT_OCEAN]: bahamutIcon,
  [ChainID.BAHAMUT_HORIZON]: bahamutIcon,

  [ChainID.BASE]: baseIcon,
  [ChainID.BASE_TESTNET]: baseIcon,
  [ChainID.BASE_SEPOLIA]: baseIcon,

  [ChainID.BERACHAIN]: berachainIcon,
  [ChainID.BERACHAIN_TESTNET]: berachainIcon,
  [ChainID.BERACHAIN_GUARDED_TESTNET]: berachainIcon,
  [ChainID.BERACHAIN_GUARDED_TESTNET_EVM]: berachainIcon,

  [ChainID.BOTANIX]: botanixIcon,
  [ChainID.BOTANIX_TESTNET]: botanixIcon,

  [ChainID.BLAST]: blastIcon,
  [ChainID.BLAST_TESTNET_SEPOLIA]: blastIcon,

  [ChainID.B2]: b2Icon,
  [ChainID.B2_HABITAT_TESTNET]: b2Icon,
  [ChainID.BTC_MAINNET]: btcIcon,
  [ChainID.BTC]: btcIcon,
  [ChainID.BTC_BLOCKBOOK]: btcIcon,
  [ChainID.BTC_BLOCKBOOK_SIGNET]: btcIcon,
  [ChainID.BTC_SIGNET]: btcIcon,
  [ChainID.BTTC]: bttcIcon,
  [ChainID.BITLAYER]: bitlayerIcon,
  [ChainID.BITLAYER_TESTNET]: bitlayerIcon,

  [ChainID.CELO]: celoIcon,
  [ChainID.CELO_BAKLAVA]: celoIcon,
  [ChainID.CELO_SEPOLIA]: celoIcon,
  [ChainID.CHILIZ]: chilizIcon,
  [ChainID.CHILIZ_TESTNET]: chilizIcon,
  [ChainID.CORE]: coreIcon,

  [ChainID.CORN]: cornIcon,
  [ChainID.CORN_MAIZENET]: cornIcon,
  [ChainID.CORN_TESTNET]: cornIcon,

  [ChainID.DOGEOS]: dogeosIcon,
  [ChainID.DOGEOS_TESTNET]: dogeosIcon,

  [ChainID.ETH]: ethIcon,
  [ChainID.ETH_BEACON]: ethIcon,
  [ChainID.ETH_KOVAN]: ethIcon,
  [ChainID.ETH_RINKEBY]: ethIcon,
  [ChainID.ETH_ROPSTEN]: ethIcon,
  [ChainID.ETH_SEPOLIA]: ethIcon,
  [ChainID.ETH_SEPOLIA_BEACON]: ethIcon,
  [ChainID.ETH_HOLESKY]: ethIcon,
  [ChainID.ETH_HOLESKY_BEACON]: ethIcon,
  [ChainID.ETH_HOODI]: ethIcon,
  [ChainID.ETH_HOODI_BEACON]: ethIcon,
  [ChainID.ELECTRONEUM]: electroneumIcon,
  [ChainID.ELECTRONEUM_TESTNET]: electroneumIcon,
  [ChainID.ETHERLINK]: etherlinkIcon,
  [ChainID.ETHERLINK_TESTNET]: etherlinkIcon,
  [ChainID.ETHERLINK_SHADOWNET_TESTNET]: etherlinkIcon,

  [ChainID.FLARE]: flareIcon,
  [ChainID.FLARE_C]: flareIcon,
  [ChainID.FLARE_EVM]: flareIcon,
  [ChainID.FLARE_P]: flareIcon,
  [ChainID.FLARE_X]: flareIcon,
  [ChainID.FLARE_COSTON]: flareIcon,
  [ChainID.FLARE_COSTON_EVM]: flareIcon,
  [ChainID.FLARE_COSTON_C]: flareIcon,
  [ChainID.FLARE_COSTON_P]: flareIcon,
  [ChainID.FLARE_COSTON_X]: flareIcon,
  [ChainID.FLARE_COSTON2]: flareIcon,
  [ChainID.FLARE_COSTON2_EVM]: flareIcon,
  [ChainID.FLARE_COSTON2_C]: flareIcon,
  [ChainID.FLARE_COSTON2_P]: flareIcon,
  [ChainID.FLARE_COSTON2_X]: flareIcon,
  [ChainID.FLARE_SONGBIRD]: flareIcon,
  [ChainID.FLARE_SONGBIRD_EVM]: flareIcon,
  [ChainID.FLARE_SONGBIRD_C]: flareIcon,
  [ChainID.FLARE_SONGBIRD_P]: flareIcon,
  [ChainID.FLARE_SONGBIRD_X]: flareIcon,
  [ChainID.FANTOM]: ftmIcon,
  [ChainID.FANTOM_TESTNET]: ftmIcon,
  [ChainID.FILECOIN]: filecoinIcon,
  [ChainID.FUEL]: fuelIcon,
  [ChainID.FUEL_REST]: fuelIcon,
  [ChainID.FUEL_SEPOLIA]: fuelIcon,

  [ChainID.GNOSIS]: gnosisIcon,
  [ChainID.GNOSIS_BEACON]: gnosisIcon,
  [ChainID.GNOSIS_TESTNET]: gnosisIcon,
  [ChainID.GNOSIS_TESTNET_BEACON]: gnosisIcon,
  [ChainID.GRAVITY]: gravityIcon,
  [ChainID.HARMONY]: harmonyIcon,
  [ChainID.HORIZEN]: horizenIcon,
  [ChainID.HORIZEN_EVM]: horizenIcon,
  [ChainID.HORIZEN_TESTNET]: horizenIcon,
  [ChainID.HORIZEN_TESTNET_EVM]: horizenIcon,
  [ChainID.HECO]: hecoIcon,
  [ChainID.HECO_TESTNET]: hecoIcon,
  [ChainID.IOTA_EVM]: iotaIcon,
  [ChainID.IOTA_EVM_TESTNET]: iotaIcon,
  [ChainID.IOTA]: iotaIcon,
  [ChainID.IOTA_TESTNET]: iotaIcon,
  [ChainID.IOTEX]: iotexIcon,
  [ChainID.IOTEX_TESTNET]: iotexIcon,

  [ChainID.KAVA]: kavaIcon,
  [ChainID.KAVA_COSMOS_REST]: kavaIcon,
  [ChainID.KAVA_EVM]: kavaIcon,
  [ChainID.KAVA_TENDERMINT_REST]: kavaIcon,
  [ChainID.KAVA_TENDERMINT_RPC]: kavaIcon,
  [ChainID.KAVA_TENDERMINT_GRPC]: kavaIcon,
  [ChainID.KAVA_TESTNET]: kavaIcon,
  [ChainID.KAVA_COSMOS_REST_TESTNET]: kavaIcon,
  [ChainID.KAVA_EVM_TESTNET]: kavaIcon,
  [ChainID.KAVA_TENDERMINT_REST_TESTNET]: kavaIcon,
  [ChainID.KAVA_TENDERMINT_RPC_TESTNET]: kavaIcon,

  [ChainID.KITE]: kiteIcon,
  [ChainID.KINTO]: kintoIcon,
  [ChainID.KAIA]: kaiaIcon,
  [ChainID.KAIA_TESTNET]: kaiaIcon,
  [ChainID.KUSAMA]: kusamaIcon,
  [ChainID.MANTLE]: mantleIcon,
  [ChainID.MANTLE_TESTNET]: mantleIcon,
  [ChainID.MANTLE_SEPOLIA]: mantleIcon,
  [ChainID.MATCHAIN]: matchainIcon,
  [ChainID.METIS]: metisIcon,
  [ChainID.MOONBEAM]: moonbeamIcon,
  [ChainID.MULTICHAIN]: multichainIcon,
  [ChainID.MOVEMENT_BARDOCK]: movementIcon,
  [ChainID.MOVEMENT_BARDOCK_REST]: movementIcon,
  [ChainID.MOVEMENT_MAINNET]: movementIcon,
  [ChainID.MOVEMENT_MAINNET_REST]: movementIcon,
  [ChainID.MONAD]: monadIcon,
  [ChainID.MONAD_TESTNET]: monadIcon,
  [ChainID.MIDNIGHT]: midnightIcon,
  [ChainID.MIDNIGHT_TESTNET]: midnightIcon,

  [ChainID.NEAR]: nearIcon,
  [ChainID.NEURA]: neuraIcon,
  [ChainID.NEURA_TESTNET]: neuraIcon,
  [ChainID.WHITECHAIN]: whitechainIcon,
  [ChainID.WHITECHAIN_TESTNET]: whitechainIcon,
  [ChainID.WORLDCHAIN]: worldchainIcon,
  [ChainID.NERVOS]: nervosIcon,
  [ChainID.NERVOS_EVM]: nervosIcon,
  [ChainID.NERVOS_CKB]: nervosIcon,
  [ChainID.NERVOS_GW]: nervosIcon,
  [ChainID.XLAYER]: okxX1Icon,
  [ChainID.XLAYER_TESTNET]: okxX1Icon,
  [ChainID.OPTIMISM]: optimisimIcon,
  [ChainID.OPTIMISM_TESTNET]: optimisimIcon,
  [ChainID.OPTIMISM_SEPOLIA]: optimisimIcon,
  [ChainID.PLASMA]: plasmaIcon,
  [ChainID.POLKADOT]: polkadotIcon,
  [ChainID.POLKADOT_ASSET_HUB]: polkadotIcon,
  [ChainID.POLYGON]: polygonIcon,
  [ChainID.POLYGON_MUMBAI]: polygonIcon,
  [ChainID.POLYGON_AMOY]: polygonIcon,
  [ChainID.POLYGON_ZKEVM]: polygonZkevmIcon,
  [ChainID.POLYGON_ZKEVM_TESTNET]: polygonZkevmIcon,
  [ChainID.POLYGON_ZKEVM_CARDONA]: polygonZkevmIcon,
  [ChainID.REDBELLY]: redbellyIcon,

  [ChainID.ROBINHOOD]: robinhoodIcon,

  [ChainID.ROLLUX]: rolluxIcon,
  [ChainID.ROLLUX_OPNODE]: rolluxIcon,
  [ChainID.ROLLUX_OPNODE_TESTNET]: rolluxIcon,
  [ChainID.ROLLUX_TESTNET]: rolluxIcon,

  [ChainID.STELLAR]: stellarIcon,
  [ChainID.STELLAR_HORIZON]: stellarIcon,
  [ChainID.STELLAR_SOROBAN]: stellarIcon,
  [ChainID.STELLAR_TESTNET]: stellarIcon,
  [ChainID.STELLAR_TESTNET_HORIZON]: stellarIcon,
  [ChainID.STELLAR_TESTNET_SOROBAN]: stellarIcon,

  [ChainID.SCROLL]: scrollIcon,
  [ChainID.SCROLL_TESTNET]: scrollIcon,
  [ChainID.SCROLL_SEPOLIA_TESTNET]: scrollIcon,

  [ChainID.SECRET]: secretIcon,
  [ChainID.SECRET_COSMOS]: secretIcon,
  [ChainID.SECRET_COSMOS_GRPC_WEB]: secretIcon,
  [ChainID.SECRET_COSMOS_REST]: secretIcon,
  [ChainID.SECRET_REST]: secretIcon,
  [ChainID.SECRET_RPC]: secretIcon,

  [ChainID.SEI]: seiIcon,
  [ChainID.SEI_EVM]: seiIcon,
  [ChainID.SEI_COSMOS_REST]: seiIcon,
  [ChainID.SEI_REST]: seiIcon,
  [ChainID.SEI_RPC]: seiIcon,
  [ChainID.SEI_TENDERMINT_GRPC]: seiIcon,

  [ChainID.SOLANA]: solIcon,
  [ChainID.SOLANA_DEVNET]: solIcon,
  [ChainID.SYSCOIN]: syscoinIcon,

  [ChainID.TAC]: tacIcon,
  [ChainID.TAC_EVM]: tacIcon,
  [ChainID.TAC_TENDERMINT_JSON_RPC]: tacIcon,
  [ChainID.TAC_TENDERMINT_REST]: tacIcon,
  [ChainID.TAC_TENDERMINT_GRPC]: tacIcon,
  [ChainID.TAC_COSMOS_REST]: tacIcon,
  [ChainID.TAC_COSMOS_GRPC_WEB]: tacIcon,
  [ChainID.TAC_TESTNET_SPB]: tacIcon,
  [ChainID.TAC_TESTNET_SPB_GRPC]: tacIcon,
  [ChainID.TAC_TESTNET_SPB_COSMOS_GRPC]: tacIcon,
  [ChainID.TAC_TESTNET_SPB_COSMOS_REST]: tacIcon,
  [ChainID.TAC_TESTNET_SPB_EVM]: tacIcon,
  [ChainID.TAC_TESTNET_SPB_TENDERMINT_REST]: tacIcon,
  [ChainID.TAC_TESTNET_SPB_TENDERMINT_RPC]: tacIcon,

  [ChainID.TAIKO]: taikoIcon,
  [ChainID.TAIKO_HOODI]: taikoIcon,
  [ChainID.TELOS]: telosIcon,

  [ChainID.TON]: tonIcon,
  [ChainID.TON_REST]: tonIcon,
  [ChainID.TON_RPC]: tonIcon,

  [ChainID.TRON]: tronIcon,
  [ChainID.TRON_REST]: tronIcon,
  [ChainID.TRON_JSON_RPC]: tronIcon,
  [ChainID.TENET]: tenetIcon,
  [ChainID.TENET_EVM]: tenetIcon,
  [ChainID.XDAI]: stakeIcon,
  [ChainID.SUI]: suiIcon,
  [ChainID.SUI_TESTNET]: suiIcon,
  [ChainID.SUI_GRPC]: suiIcon,
  [ChainID.SUI_GRPC_ARCHIVE]: suiIcon,
  [ChainID.SUI_GRAPHQL]: suiIcon,
  [ChainID.SUI_TESTNET_GRPC]: suiIcon,

  [ChainID.UNICHAIN]: unichainIcon,

  [ChainID.XAI]: xaiIcon,
  [ChainID.XAI_TESTNET]: xaiIcon,
  [ChainID.XDC]: xdcIcon,
  [ChainID.XDC_TESTNET]: xdcIcon,

  [ChainID.XPHERE]: xphereIcon,
  [ChainID.XPHERE_TESTNET]: xphereIcon,

  [ChainID.ZETACHAIN]: zetachainIcon,
  [ChainID.ZETACHAIN_COSMOS_REST_ATHENS_TESTNET]: zetachainIcon,
  [ChainID.ZETACHAIN_EVM_ATHENS_TESTNET]: zetachainIcon,
  [ChainID.ZETACHAIN_TENDERMINT_REST_ATHENS_TESTNET]: zetachainIcon,
  [ChainID.ZETACHAIN_TENDERMINT_RPC_ATHENS_TESTNET]: zetachainIcon,
  [ChainID.ZETACHAIN_ATHENS_TESTNET]: zetachainIcon,
  [ChainID.ZKSYNC_ERA]: zksyncEraIcon,
  [ChainID.ZKSYNC_ERA_SEPOLIA]: zksyncEraIcon,
  [ChainID.ZKSYNC_ERA_TESTNET]: zksyncEraIcon,

  [ChainID.LINEA]: lineaIcon,

  [ChainID.ZERO_G]: zeroGIcon,
  [ChainID.ZERO_G_EVM]: zeroGIcon,
  [ChainID.ZERO_G_BEACONKIT_REST]: zeroGIcon,
  [ChainID.ZERO_G_GALILEO_TESTNET]: zeroGIcon,
  [ChainID.ZERO_G_GALILEO_BEACONKIT_REST]: zeroGIcon,
  [ChainID.ZERO_G_GALILEO_EVM]: zeroGIcon,
  [ChainID.ZERO_G_GALILEO_TENDERMINT_REST]: zeroGIcon,
  [ChainID.ZERO_G_GALILEO_TENDERMINT_RPC]: zeroGIcon,

  [ChainID.ZKVERIFY]: zkverifyIcon,
  [ChainID.ZKVERIFY_MAINNET]: zkverifyIconDark,
  [ChainID.ZKVERIFY_TESTNET]: zkverifyIcon,
  [ChainID.ZKVERIFY_VOLTA_TESTNET]: zkverifyIcon,
  [ChainID.ZKVERIFY_VFLOW_PARACHAIN_MAINNET]: zkverifyIconDark,
  [ChainID.ZKVERIFY_VFLOW_PARACHAIN_TESTNET]: zkverifyIcon,

  [ChainID.STORY]: storyIcon,
  [ChainID.STORY_AENEID]: storyIcon,
  [ChainID.STORY_ODYSSEY]: storyIcon,

  [ChainID.SWELL]: swellIcon,
  [ChainID.SWELL_SEPOLIA]: swellIcon,

  [ChainID.SONIC]: sonicIcon,
  [ChainID.SONIC_BLAZE_TESTNET]: sonicIcon,

  [ChainID.SOMNIA]: somniaIcon,
  [ChainID.SOMNIA_TESTNET]: somniaIcon,

  [ChainID.STATUS]: statusIcon,
  [ChainID.STATUS_TESTNET]: statusIcon,

  [ChainID.XRP]: xrpIcon,
};

const darkModeChainIcons: Partial<Record<ChainID, string>> = {
  ...chainIcons,
  [ChainID.ALLORA]: alloraIconDark,
  [ChainID.ALLORA_MAINNET_REST]: alloraIconDark,
  [ChainID.ALLORA_MAINNET_RPC]: alloraIconDark,
  [ChainID.ALLORA_MAINNET_GRPC]: alloraIconDark,
  [ChainID.ALLORA_MAINNET_COSMOS_REST]: alloraIconDark,
  [ChainID.ALLORA_TESTNET]: alloraIconDark,
  [ChainID.ALLORA_TESTNET_REST]: alloraIconDark,
  [ChainID.ALLORA_TESTNET_RPC]: alloraIconDark,
  [ChainID.ALLORA_TESTNET_GRPC]: alloraIconDark,
  [ChainID.ALLORA_TESTNET_COSMOS_REST]: alloraIconDark,
  [ChainID.ATLETA]: atletaIconDark,
  [ChainID.ATLETA_OLYMPIA]: atletaIconDark,
  [ChainID.ARBITRUM_NOVA]: arbitrumNovaIconDark,
  [ChainID.BERACHAIN]: berachainIconDark,
  [ChainID.BERACHAIN_TESTNET]: berachainIconDark,
  [ChainID.BERACHAIN_GUARDED_TESTNET]: berachainIconDark,
  [ChainID.BERACHAIN_GUARDED_TESTNET_EVM]: berachainIconDark,
  [ChainID.BITLAYER]: bitlayerIconDark,
  [ChainID.BITLAYER_TESTNET]: bitlayerIconDark,
  [ChainID.BTTC]: bttcIconDark,
  [ChainID.BLAST]: blastIconDark,
  [ChainID.BLAST_TESTNET_SEPOLIA]: blastIconDark,
  [ChainID.ETH]: ethIconDark,
  [ChainID.ETH_BEACON]: ethIconDark,
  [ChainID.ETH_KOVAN]: ethIconDark,
  [ChainID.ETH_RINKEBY]: ethIconDark,
  [ChainID.ETH_ROPSTEN]: ethIconDark,
  [ChainID.ETH_SEPOLIA]: ethIconDark,
  [ChainID.ETH_SEPOLIA_BEACON]: ethIconDark,
  [ChainID.ETH_HOLESKY]: ethIconDark,
  [ChainID.ETH_HOLESKY_BEACON]: ethIconDark,
  [ChainID.ETH_HOODI]: ethIconDark,
  [ChainID.ETH_HOODI_BEACON]: ethIconDark,
  [ChainID.ELECTRONEUM]: electroneumIconDark,
  [ChainID.ELECTRONEUM_TESTNET]: electroneumIconDark,
  [ChainID.KINTO]: kintoIconDark,
  [ChainID.KUSAMA]: kusamaIconDark,
  [ChainID.MANTLE]: mantleIconDark,
  [ChainID.MANTLE_TESTNET]: mantleIconDark,
  [ChainID.MANTLE_SEPOLIA]: mantleIconDark,
  [ChainID.MOONBEAM]: moonbeamIconDark,
  [ChainID.NEAR]: nearIconDark,
  [ChainID.NERVOS]: nervosIconDark,
  [ChainID.NERVOS_EVM]: nervosIconDark,
  [ChainID.NERVOS_CKB]: nervosIconDark,
  [ChainID.NERVOS_GW]: nervosIconDark,
  [ChainID.XLAYER]: okxX1IconDark,
  [ChainID.XLAYER_TESTNET]: okxX1IconDark,
  [ChainID.TENET]: tenetIconDark,
  [ChainID.SOLANA]: solIconDark,
  [ChainID.SOLANA_DEVNET]: solIconDark,
  [ChainID.SUI]: suiIconDark,
  [ChainID.SUI_TESTNET]: suiIconDark,
  [ChainID.SUI_GRPC]: suiIconDark,
  [ChainID.SUI_GRPC_ARCHIVE]: suiIconDark,
  [ChainID.SUI_GRAPHQL]: suiIconDark,
  [ChainID.SUI_TESTNET_GRPC]: suiIconDark,
  [ChainID.ZKSYNC_ERA]: zksyncEraIconDark,
  [ChainID.ZKSYNC_ERA_SEPOLIA]: zksyncEraIconDark,
  [ChainID.ZKSYNC_ERA_TESTNET]: zksyncEraIconDark,
  [ChainID.XDC]: xdcIconDark,
  [ChainID.XDC_TESTNET]: xdcIconDark,
  [ChainID.LINEA]: lineaIconDark,
  [ChainID.STELLAR]: stellarIconDark,
  [ChainID.STELLAR_HORIZON]: stellarIconDark,
  [ChainID.STELLAR_TESTNET]: stellarIconDark,
  [ChainID.STELLAR_TESTNET_HORIZON]: stellarIconDark,
  [ChainID.STELLAR_TESTNET_SOROBAN]: stellarIconDark,
  [ChainID.SYSCOIN]: syscoinIconDark,
  [ChainID.TAIKO]: taikoIconDark,
  [ChainID.TAIKO_HOODI]: taikoIconDark,
  [ChainID.TELOS]: telosIconDark,
  [ChainID.SCROLL]: scrollIconDark,
  [ChainID.SCROLL_TESTNET]: scrollIconDark,
  [ChainID.SCROLL_SEPOLIA_TESTNET]: scrollIconDark,
  [ChainID.CORE]: coreIconDark,
  [ChainID.SEI]: seiIconDark,
  [ChainID.SEI_COSMOS_REST]: seiIconDark,
  [ChainID.SEI_EVM]: seiIconDark,
  [ChainID.SEI_REST]: seiIconDark,
  [ChainID.SEI_RPC]: seiIconDark,
  [ChainID.SEI_TENDERMINT_GRPC]: seiIconDark,
  [ChainID.SONIC]: sonicIconDark,
  [ChainID.SONIC_BLAZE_TESTNET]: sonicIconDark,
  [ChainID.KAIA]: kaiaIconDark,
  [ChainID.KAIA_TESTNET]: kaiaIconDark,
  [ChainID.AVAIL]: availIconDark,
  [ChainID.AVAIL_GOLDBERG_TESTNET]: availIconDark,
  [ChainID.AVAIL_TURING_TESTNET]: availIconDark,

  [ChainID.TAC]: tacIconDark,
  [ChainID.TAC_EVM]: tacIconDark,
  [ChainID.TAC_TENDERMINT_JSON_RPC]: tacIconDark,
  [ChainID.TAC_TENDERMINT_REST]: tacIconDark,
  [ChainID.TAC_TENDERMINT_GRPC]: tacIconDark,
  [ChainID.TAC_COSMOS_REST]: tacIconDark,
  [ChainID.TAC_COSMOS_GRPC_WEB]: tacIconDark,
  [ChainID.TAC_TESTNET_SPB]: tacIconDark,
  [ChainID.TAC_TESTNET_SPB_GRPC]: tacIconDark,
  [ChainID.TAC_TESTNET_SPB_COSMOS_GRPC]: tacIconDark,
  [ChainID.TAC_TESTNET_SPB_COSMOS_REST]: tacIconDark,
  [ChainID.TAC_TESTNET_SPB_EVM]: tacIconDark,
  [ChainID.TAC_TESTNET_SPB_TENDERMINT_REST]: tacIconDark,
  [ChainID.TAC_TESTNET_SPB_TENDERMINT_RPC]: tacIconDark,

  [ChainID.ZERO_G]: zeroGIconDark,
  [ChainID.ZERO_G_EVM]: zeroGIconDark,
  [ChainID.ZERO_G_BEACONKIT_REST]: zeroGIconDark,
  [ChainID.ZERO_G_GALILEO_TESTNET]: zeroGIconDark,
  [ChainID.ZERO_G_GALILEO_BEACONKIT_REST]: zeroGIconDark,
  [ChainID.ZERO_G_GALILEO_EVM]: zeroGIconDark,
  [ChainID.ZERO_G_GALILEO_TENDERMINT_REST]: zeroGIconDark,
  [ChainID.ZERO_G_GALILEO_TENDERMINT_RPC]: zeroGIconDark,

  [ChainID.ZKVERIFY]: zkverifyIconDark,
  [ChainID.ZKVERIFY_MAINNET]: zkverifyIconDark,
  [ChainID.ZKVERIFY_TESTNET]: zkverifyIconDark,
  [ChainID.ZKVERIFY_VOLTA_TESTNET]: zkverifyIconDark,
  [ChainID.ZKVERIFY_VFLOW_PARACHAIN_MAINNET]: zkverifyIconDark,
  [ChainID.ZKVERIFY_VFLOW_PARACHAIN_TESTNET]: zkverifyIconDark,

  [ChainID.XPHERE]: xphereIconDark,
  [ChainID.XPHERE_TESTNET]: xphereIconDark,

  [ChainID.MATCHAIN]: matchainIconDark,

  [ChainID.IOTA_EVM]: iotaIconDark,
  [ChainID.IOTA_EVM_TESTNET]: iotaIconDark,
  [ChainID.IOTA]: iotaIconDark,
  [ChainID.IOTA_TESTNET]: iotaIconDark,
  [ChainID.SOMNIA]: somniaIconDark,
  [ChainID.SOMNIA_TESTNET]: somniaIconDark,
  [ChainID.XRP]: xrpIconDark,

  [ChainID.MIDNIGHT]: midnightIconDark,
  [ChainID.MIDNIGHT_TESTNET]: midnightIconDark,

  [ChainID.STATUS]: statusIconDark,
  [ChainID.STATUS_TESTNET]: statusIconDark,

  [ChainID.HYPEREVM]: hyperevmIconDark,
};

const chainNameIcons: Record<string, string> = {
  abchain_mainnet: abchainIcon,
  abchain_testnet: abchainIcon,
  allora_mainnet: alloraIcon,
  allora_cosmos_mainnet: alloraIcon,
  allora_mainnet_grpc: alloraIcon,
  allora_testnet: alloraIcon,
  allora_cosmos_testnet: alloraIcon,
  allora_testnet_grpc: alloraIcon,
  zetachain_testnet: zetachainIcon,
  zetachain_evm_testnet: zetachainIcon,
  zetachain_tendermint_testnet: zetachainIcon,
  zetachain_athens_testnet: zetachainIcon,
  zetachain_evm_athens_testnet: zetachainIcon,
  zetachain_tendermint_athens_testnet: zetachainIcon,
  tenet_evm: tenetIcon,
  horizen_eon: horizenIcon,
  horizen_gobi_testnet: horizenIcon,
  aptos_testnet: aptosIcon,
  filecoin_testnet: filecoinIcon,
  zksync_era_testnet: zksyncEraIcon,
  zksync_era_sepolia: zksyncEraIcon,
  berachain_guarded_testnet_evm: berachainIcon,
  sei_cosmos: seiIcon,
  sei_grpc: seiIcon,
  sei: seiIcon,
  sei_evm: seiIcon,
  stellar_horizon: stellarIcon,
  stellar_soroban: stellarIcon,
  stellar_testnet_horizon: stellarIcon,
  stellar_testnet_soroban: stellarIcon,
  sui_grpc: suiIcon,
  [SUI_ARCHIVE_GRPC_PATH]: suiIcon,
  sui_graphql: suiIcon,
  sui_testnet_grpc: suiIcon,
  kava_evm: kavaIcon,
  kava_api: kavaIcon,
  kava_rpc: kavaIcon,
  kava_testnet_api: kavaIcon,
  kava_testnet_evm: kavaIcon,
  kava_testnet_rpc: kavaIcon,
  kava_grpc: kavaIcon,
  kite_mainnet: kiteIcon,
  '0g_mainnet_evm': zeroGIcon,
  '0g_mainnet_beaconkit': zeroGIcon,
  '0g_galileo_testnet_beaconkit': zeroGIcon,
  '0g_galileo_testnet_evm': zeroGIcon,
  '0g_galileo_testnet_tendermint': zeroGIcon,
  ton_api_v2: tonIcon,
  fuel_sepolia: fuelIcon,
  story_mainnet: storyIcon,
  story_odyssey: storyIcon,
  story_aeneid_testnet: storyIcon,
  swell_sepolia: swellIcon,
  goat_testnet: goatIcon,
  corn_maizenet: cornIcon,
  corn_testnet: cornIcon,
  botanix_mainnet: botanixIcon,
  botanix_testnet: botanixIcon,

  tac: tacIcon,
  'tac_grpc-web': tacIcon,
  tac_cosmos: tacIcon,
  tac_tendermint: tacIcon,
  tac_tendermint_grpc: tacIcon,
  tac_spb: tacIcon,
  'tac_spb_grpc-web': tacIcon,
  tac_spb_cosmos: tacIcon,
  tac_spb_tendermint: tacIcon,
  tac_spb_tendermint_grpc: tacIcon,
  redbelly_mainnet: redbellyIcon,
  robinhood_mainnet: robinhoodIcon,
  sonic_mainnet: sonicIcon,
  sonic_blaze_testnet: sonicIcon,
  goat_mainnet: goatIcon,
  matchain_mainnet: matchainIcon,
  status: statusIcon,
  status_testnet: statusIcon,
  iota_mainnet: iotaIcon,
  iota_evm_testnet: iotaIcon,
  iota_testnet: iotaIcon,
  somnia_mainnet: somniaIcon,
  somnia_testnet: somniaIcon,
  neura_testnet: neuraIcon,
  whitechain_testnet: whitechainIcon,
  xrp_mainnet: xrpIcon,
  etherlink_mainnet: etherlinkIcon,
  etherlink_testnet: etherlinkIcon,
  etherlink_shadownet_testnet: etherlinkIcon,
  monad_mainnet: monadIcon,
  monad_testnet: monadIcon,
  midnight_mainnet: midnightIcon,
  midnight_testnet: midnightIcon,

  aapi_v2: multichainIcon,
  zkverify_mainnet: zkverifyIcon,
  zkverify_volta_testnet: zkverifyIcon,
  vflow_mainnet: zkverifyIcon,
  vflow_testnet: zkverifyIcon,
  vflow_volta_testnet: zkverifyIcon,
  xphere_mainnet: xphereIcon,
  xphere_testnet: xphereIcon,
  atleta_mainnet: atletaIcon,
  taiko_hoodi_testnet: taikoIcon,
  dogeos_testnet: dogeosIcon,
  polkadot_mainnet_asset_hub: polkadotIcon,
  unichain_mainnet: unichainIcon,
  hyperevm: hyperevmIcon,
};

const darkChainNameIcons: Record<string, string> = {
  ...chainNameIcons,
  allora_mainnet: alloraIconDark,
  allora_cosmos_mainnet: alloraIconDark,
  allora_mainnet_grpc: alloraIconDark,
  allora_testnet: alloraIconDark,
  allora_cosmos_testnet: alloraIconDark,
  allora_testnet_grpc: alloraIconDark,
  tenet_evm: tenetIconDark,
  berachain_guarded_testnet_evm: berachainIconDark,
  stellar_horizon: stellarIconDark,
  stellar_soroban: stellarIconDark,
  stellar_testnet_horizon: stellarIconDark,
  stellar_testnet_soroban: stellarIconDark,
  sui_grpc: suiIconDark,
  [SUI_ARCHIVE_GRPC_PATH]: suiIconDark,
  sui_graphql: suiIconDark,
  sui_testnet_grpc: suiIconDark,
  '0g_mainnet_evm': zeroGIconDark,
  '0g_mainnet_beaconkit': zeroGIconDark,
  '0g_galileo_testnet_beaconkit': zeroGIconDark,
  '0g_galileo_testnet_evm': zeroGIconDark,
  '0g_galileo_testnet_tendermint': zeroGIconDark,

  tac: tacIconDark,
  tac_spb: tacIconDark,
  'tac_spb_grpc-web': tacIconDark,
  tac_spb_cosmos: tacIconDark,
  tac_spb_tendermint: tacIconDark,
  tac_spb_tendermint_grpc: tacIconDark,
  sonic_mainnet: sonicIconDark,
  sonic_blaze_testnet: sonicIconDark,
  matchain_mainnet: matchainIconDark,
  iota_mainnet: iotaIconDark,
  iota_evm_testnet: iotaIconDark,
  iota_testnet: iotaIconDark,
  somnia_mainnet: somniaIconDark,
  somnia_testnet: somniaIconDark,
  status: statusIconDark,
  status_testnet: statusIconDark,
  xrp_mainnet: xrpIconDark,
  midnight_mainnet: midnightIconDark,
  midnight_testnet: midnightIconDark,
  zkverify_volta_testnet: zkverifyIconDark,
  vflow_testnet: zkverifyIconDark,
  zkverify_mainnet: zkverifyIconDark,
  vflow_mainnet: zkverifyIconDark,
  vflow_volta_testnet: zkverifyIconDark,
  xphere_mainnet: xphereIconDark,
  xphere_testnet: xphereIconDark,
  atleta_mainnet: atletaIconDark,
  taiko_hoodi_testnet: taikoIconDark,
  hyperevm: hyperevmIconDark,
};

export function getChainIcon(name: string, isLightTheme: boolean) {
  const iconNameMap = isLightTheme ? chainNameIcons : darkChainNameIcons;

  if (name in iconNameMap) {
    return iconNameMap[name];
  }

  const iconMap = isLightTheme ? chainIcons : darkModeChainIcons;

  return iconMap[name as keyof typeof chainIcons] || defaultIcon;
}
